module.exports = __webpack_public_path__ + "img/506.cadfb012.png";